import { Icon } from '@components/Icon/Icon';
import classNames from 'classnames';

type Props = {
  label: string;
  styleVariant?: string;
  sizeVariant?: string;
  icon?: boolean;
  className?: string;
  type?: 'a' | 'button';
};

export const Button = ({
  label,
  sizeVariant,
  styleVariant,
  icon,
  className = '',
  type = 'a',
}: Props) => {
  const classes = classNames('bo-btn', `${className}`, {
    [`bo-btn--${sizeVariant}`]: !!sizeVariant,
    [`bo-btn--${styleVariant}`]: !!styleVariant,
  });

  const InnerButton = () => (
    <>
      {icon && <Icon iconName="plus" width={10} height={10} wrapperClass="" />}
      <span>{label}</span>
    </>
  );

  return type === 'button' ? (
    <button className={classes}>
      <InnerButton />
    </button>
  ) : (
    <a href="#" className={classes}>
      <InnerButton />
    </a>
  );
};
